<template>
  <div class="Register full-height">
    <ld-header
      :left-options="{ backText: '返回' }"
      @click-right="newConsole"
    >
      <template #right>
        &nbsp;
      </template>
    </ld-header>

    <div class="regsiter-cnt">
      <div class="welcome font24 font-lg">
        企业注册
      </div>

      <!-- 暂时不支持个人注册 -->
      <van-row class="register-input-title font-lg gray font20">
        <van-col
          span="6"
          :class="registerType === 1 ? 'black' : ''"
          @click="changeRegisterType(1)"
        >
          企业
        </van-col>
        <van-col
          span="6"
          class="vaild van-hairline--left"
          :class="registerType === 2 ? 'black' : ''"
          @click="changeRegisterType(2)"
          v-if="false"
        >
          个人
        </van-col>
        <div
          class="bottom-line bg-main"
          ref="bottomLine"
        />
      </van-row>

      <div v-show="registerType === 1">
        <reg-input
          :value.sync="corpName"
          placeholder="请输入企业全称"
        />
      </div>

      <reg-input
        :value.sync="userName"
        :placeholder="registerType === 1 ? '请输入联系人姓名' : '请输入姓名'"
      />

      <reg-input
        :value.sync="telphone"
        :placeholder="registerType === 1 ? '请输入联系人电话' : '请输入手机号码'"
        ref="telphone"
      />

      <div
        class="box"
        v-show="registerType === 2"
      >
        <van-field
          v-model="smsCode"
          center
          clearable
          placeholder="请输入短信验证码"
        >
          <template #button>
            <ld-button
              size="sm"
              main2
              @click.native="getRegisterSmsCode"
              :disabled="smsCodeDisabled"
              class="font12"
              style="width:130px;"
            >
              <span v-show="smsCodeDisabled">
                {{ smsCodeTime }}s后重新获取
              </span>
              <span v-show="smsCodeDisabled==false">获取验证码</span>
            </ld-button>
          </template>
        </van-field>
        <van-field
          v-show="isYXSL==false"
          v-model.trim="corpNo"
          placeholder="企业代码（选填）"
        />
      </div>

      <div
        class="box"
        v-show="isYXSL"
      >
        <van-cell :border="false">
          <van-radio-group
            v-model="allotType"
            direction="horizontal"
            icon-size="16"
            @change="allotTypeChange"
          >
            <van-row class="full-width">
              <van-col span="16">
                <van-radio name="0">
                  输入服务商代码
                </van-radio>
              </van-col>
              <van-col
                span="8"
                class="text-right"
              >
                <van-radio name="1">
                  自动分配
                </van-radio>
              </van-col>
            </van-row>
          </van-radio-group>
        </van-cell>
        <van-field
          v-show="allotType == 0"
          :readonly="isReadonly"
          v-model="compCode"
          center
          clearable
          placeholder="请输入差旅服务商代码"
        />
        <van-field
          v-show="registerType === 2 && allotType == 0"
          v-model.trim="corpNo"
          placeholder="企业代码（选填）"
          :readonly="isReadonly"
        />
      </div>
      <div class="box">
        <ld-button
          :loading="submiting"
          :disabled="!validSuccess"
          @click.native="submit"
          main2
          size="lg"
        >
          提交注册
        </ld-button>
      </div>

      <!-- <div class="license text-center">
        点击“提交注册”即表示您同意协议：<div
          class="main-color"
          @click="showLicense"
        >
          《服务协议和隐私条款》
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Velocity from 'velocity-animate'
import ldHeader from 'Common/ldHeader'
import ldButton from 'Common/ldButton'
import regInput from './reg-input'
import { validators } from 'Utils/valid'
import { ifStrBlank } from 'Utils/string'
import {Field,Button,RadioGroup, Radio,Cell} from 'vant'
import VConsole from 'vconsole'

export default {
  components: {
    ldButton,
    ldHeader,
    regInput,
    [Field.name]:Field,
    [Button.name]:Button,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [Cell.name]:Cell,
  },
  data() {
    return {
      validators,
      submiting: false,
      corpName: '',
      userName: '',
      telphone: '',
      registerType: 1, // 1工号/手机号登录；2手机+验证码登录,
      smsCode:'',
      smsCodeTime:0,
      smsCodeDisabled:false,
      allotType:'1',
      compCode:'',
      corpNo:'',
      isReadonly:false,
      isYXSL:false
    }
  },
  created() {},
  mounted() {
    this.changeRegisterType(this.registerType)
    if(process.env.VUE_APP_addressHost){
      this.isYXSL = (process.env.VUE_APP_addressHost=='m.yixtrip.com')
    }else{
      this.isYXSL = (window.location.host=='m.yixtrip.com')
    }
  },
  methods: {
    newConsole () {
      new VConsole()
    },
    // 改变注册方式
    changeRegisterType(type) {
      this.registerType = type
      this.corpName = ''
      this.userName = ''
      this.telphone = ''
      let left = '0.2rem'
      switch (type) {
        case 2:
          left = '2.12rem'
          break
      }

      Velocity(this.$refs.bottomLine,	{
        left
      },{
        duration: '300',
        easing: 'linear'
      })
    },
    async submit() {
      if (this.registerType === 1) {
        this.corpRegister()
      } else {
        this.userRegister()
      }
    },
    // 企业注册
    async corpRegister() {
      if(!this.loginConfig.compaySuper){
        if(this.allotType==0&&!this.compCode){
          this.$toast('请输入服务商代码！')
          return
        }
        let {data={}}= await this.$api['user/queryCompId']({
          'allotType': this.allotType,//0-自己输入服务商代码 1-自动分配
          'compCode': this.compCode
        })
        if(data.compId){
          this.loginConfig.compaySuper=data.compId
        }else{
          this.$toast('未查询到该服务商，请检查服务商代码是否正确！')
          return
        }
      }

      let param = {
        compId: this.loginConfig.compaySuper,
        fullname: this.corpName,
        linkPhone: this.telphone.trim(),
        linkman: this.userName
      }
      await this.$api['user/saveVipCorpApply'](param)

      this.$dialog({
        message: '注册申请已提交，客服将尽快与您联系！'
      }).then(() => {
        this.$router.push('/login')
      })
    },
    // 个人注册
    async userRegister() {
      if(!this.smsCode){
        this.$toast('请先输入验证码！')
        return
      } else if (this.smsCode.length != 6) {
        this.$toast('验证码为六位纯数字')
        return
      }

      if(!this.userName){
        this.$toast('请先输入姓名！')
        return
      }
      var val=validators.mobile(this.telphone)
      if(val.valid){
        //验证码校验
        var self=this
        this.$api['user/smsCodeCheck']({
          phoneNumber: this.telphone,
          smsCode: this.smsCode
        }).then(res =>{
          var cache=res.data||{}
          //跳转路由到重置密码页面
          if(cache.checkResult == 0) {
            self.$dialog.alert({
              title:'提示',
              message:cache.cause
            })
          }else if(cache.checkResult == 1) {
            //注册
            self.$api['user/userRegister']({
              compId:self.loginConfig.compaySuper,
              smsCode:self.smsCode.trim(),
              phoneNumber:self.telphone.trim(),
              userName:self.userName.trim(),
              corpNo:self.corpNo.trim(),
            }).then(res => {
              self.$dialog.alert({
                title:'提示',
                message:res.data||'已注册成功！点击确定跳转登录页'
              }).then(()=>{
                self.$router.push('/login')
              })
            })
          }
        })
      }else{
        this.$toast(val.msg)
      }
    },
    // 获取短信验证码
    async getRegisterSmsCode(){
      if(this.telphone){
        var reg = /^1[3456789]\d{9}$/
        // var cache=validators.mobile(this.telphone)
        if(reg.test(this.telphone)){
          if(!this.loginConfig.compaySuper){
            if(this.allotType==0&&!this.compCode){
              this.$toast('请输入服务商代码！')
              return
            }
            let {data={}}= await this.$api['user/queryCompId']({
              'allotType': this.allotType,//0-自己输入服务商代码 1-自动分配
              'compCode': this.compCode,
            })
            if(data.compId){
              this.loginConfig.compaySuper=data.compId
              this.isReadonly=true
            }else{
              this.$toast('未查询到该服务商，请检查服务商代码是否正确！')
              return
            }
          }
          let param = {
            compId: this.loginConfig.compaySuper,
            phoneNumber: this.telphone.trim(),
            corpNo:this.corpNo
          }
          await this.$api['user/getRegisterSmsCode'](param)
          this.smsCodeDisabled=true
          this.smsCodeTime='60'
          var time=setInterval(() => {
            this.smsCodeTime-=1
            if(this.smsCodeTime==0||this.smsCodeTime<=0){
              this.smsCodeDisabled=false
              clearInterval(time)
            }
          },1000)
        }else{
          this.$toast('手机号码有误')
        }
      }else{
        this.$toast('请先输入手机号！')
      }
    },
    //自动分配获取总公司ID
    async queryCompId(){
      let {data={}}= await this.$api['user/queryCompId']({
        'allotType': this.allotType,//0-自己输入服务商代码 1-自动分配
        'compCode': this.compCode
      })
      return data
    },
    allotTypeChange(){
      if(this.allotType==1){
        this.compCode=''
        this.corpNo=''
        this.isReadonly=false
        this.loginConfig.compaySuper=''
      }
    }
  },
  computed: {
    ...mapGetters(['loginConfig']),
    validSuccess: function() {
      return this.registerType === 1
        ? !ifStrBlank(this.corpName) &&
						!ifStrBlank(this.userName) &&
						!ifStrBlank(this.telphone)
        : !ifStrBlank(this.userName) && !ifStrBlank(this.telphone)
    }
  }
}
</script>

<style lang="less" scoped>
.Register {
  color: @color-text-black;
  background-color: @color-text-white;

  .regsiter-cnt {
    padding: 0 30px;

    .welcome {
      padding: 25px 0 40px;
    }

    .register-input-title {
      position: relative;
      margin-bottom: 20px;

      .vaild {
        padding-left: 15px;
      }

      .bottom-line {
        position: absolute;
        top: 30px;
        width: 20px;
        height: 1.5px;
      }
    }
    .license {
      margin-top: 35px;
    }
  }
  .box{
      padding-top: 15px;
  }
}

</style>
